import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RcSpinnerComponent } from './rc-spinner.component';

@NgModule({
  declarations: [RcSpinnerComponent],
  imports: [CommonModule],
  exports: [RcSpinnerComponent],
})
export class RcSpinnerModule {}
